import { runningInBrowser } from "./browser";

export const isTouchDisplay = runningInBrowser && "ontouchend" in document;
